import { Types } from '@store/types';

export const setIsCommonSurveyPopupOpen = (isOpen) => {
	return {
		type: Types.SET_IS_COMMON_SURVEY_POPUP_OPEN,
		payload: isOpen
	};
};

export const setIsTrendSurveyPopupOpen = (isOpen) => {
	return {
		type: Types.SET_IS_TREND_SURVEY_POPUP_OPEN,
		payload: isOpen
	};
};

export const setIsHighlightFeedback = (isOpen) => {
	return {
		type: Types.SET_IS_HIGHLIGHT_FEEDBACK,
		payload: isOpen
	};
};
